<template>
  <div v-if="isStarted">
    <div class="text-center">
      {{ player.name }} you're in Team {{ player.team }}
      {{ player.isCodeMaster ? '(Codemaster)' : '' }}
    </div>
    <StatusBar
      :current-team="currentTeam"
      :words-missing="wordsMissing"
      class="mb-3"
    ></StatusBar>
    <div class="text-center mb-3">
      <v-btn
        small
        color="secondary"
        :disabled="currentTeam !== player.team"
        @click="endTurn"
      >
        End turn
      </v-btn>
    </div>
    <div class="board">
      <BoardCard
        v-for="cell in cells"
        :key="cell.index"
        :cell="cell"
        :enabled="isMyTurn && !player.isCodeMaster"
        @reveal="reveal"
      ></BoardCard>
    </div>
  </div>
</template>

<style scoped>
.board {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: 1rem;
}
</style>

<script>
import BoardCard from './BoardCard';
import StatusBar from './StatusBar';

export default {
  name: 'Game',
  components: { StatusBar, BoardCard },
  props: {
    connection: {
      type: Object,
      required: true,
    },
    player: {
      type: Object,
      required: true,
    },
    teamA: {
      type: Array,
      required: true,
    },
    teamB: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      screen: 'start',
      currentTeam: null,
      isStarted: false,
      wordsMissing: {
        teamA: 0,
        teamB: 0,
      },
      cells: [],
    };
  },
  computed: {
    teamAHasCodeMaster() {
      return this.teamA.filter((player) => player.isCodeMaster).length > 0;
    },
    teamBHasCodeMaster() {
      return this.teamB.filter((player) => player.isCodeMaster).length > 0;
    },
    isMyTurn() {
      return this.currentTeam === this.player.team;
    },
  },
  methods: {
    reveal(cell) {
      if (
        this.player.isCodeMaster ||
        this.player.team !== this.currentTeam ||
        !this.isStarted
      ) {
        return;
      }

      this.connection.send({ action: 'reveal', cell: cell.index });
    },
    endTurn() {
      this.connection.send({ action: 'changeTurn' });
    },
  },
  mounted() {
    this.connection.on('data', (data) => {
      switch (data.action) {
        case 'state':
          this.isStarted = data.isStarted;
          this.currentTeam = data.currentTeam;
          this.cells = data.board;
          this.wordsMissing.teamA = data.board.filter((cell) => {
            return cell.revealed === false && cell.type === 'A';
          }).length;
          this.wordsMissing.teamB = data.board.filter((cell) => {
            return cell.revealed === false && cell.type === 'B';
          }).length;
          break;

        case 'gameOver':
          this.isStarted = false;
          break;
      }
    });
  },
};
</script>
